import * as React from "react";
import { Table } from "Components/General/Table";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { fileDetailsStore } from "../FileDetailsStore";
import { ColumnProps } from "antd/lib/table";

interface TaskStateProp {
  label: string;
  value: string;
}

export const TaskState = () => {
  const [data, setData] = React.useState<TaskStateProp[]>([]);
  const [loading, setLoading] = React.useState(false);

  const fetch = async () => {
    try {
      setLoading(true);
      const { taskStatus }: API_TechnicalInfo = await API.getData(
        API_URL.FILES.getTaskStatus(projectsDataStore.projectId, fileDetailsStore.fileId)
      );
      const keys = Object.keys(taskStatus) || [];
      const result: TaskStateProp[] = keys.map((item) => ({ label: item, value: taskStatus[item] }));
      setData(result);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (!data.length && !loading) {
      (async () => await fetch())();
    }
  });

  const columns: ColumnProps<TaskStateProp>[] = [
    {
      dataIndex: "label",
    },
    {
      dataIndex: "value",
    },
  ];

  return (
    <Table
      name="fileTaskState"
      showHeader={false}
      rowKey="label"
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={false}
    />
  );
};
